export function calculateDiscount(originalPrice, discountedPrice) {
  if (originalPrice <= 0) {
    throw new Error('Original price must be greater than zero');
  }

  const discount = ((originalPrice - discountedPrice) / originalPrice) * 100;
  return discount.toFixed(2); // Returns percentage with two decimal places
}
